import RaceBar from './RaceBar';

export default RaceBar;
